import React from 'react';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import StrategyPage from '../components/legendary/StrategyPage';

export default function LegendaryLivermore() {
  return (
    <StrategyPage
      strategyKey="LIVERMORE"
      title="Livermore Pivotal Point"
      icon={<LocalFireDepartmentIcon />}
      color="#ef4444"
    />
  );
}
